export default (value) => {
  try {
    const parsed = JSON.parse(value)

    // return parsed && typeof parsed === 'object' && Object.prototype.hasOwnProperty.call(parsed, 'code') ? parsed : false
    return parsed && typeof parsed === 'object' ? parsed : false
  } catch {
    return false
  }
}
